const renderScales = {
  tile: {
    padRadius: 0.4,
    padHeight: 0.08,
    padTopOffset: 0.08,
  },
  character: {
    rigScale: 0.45,
    footOffsetFallback: 0.6,
    footOffsetMinHeightRatio: 0.5,
    focusYOffset: 0.45,
  },
  island: {
    autoRadiusBase: 0.4,
    autoRadiusEdgeMargin: 0.5,
    autoRadiusMin: 1.5,
    flatTopCompensation: 1.2,
    chunkBaseRadius: 0.95,
    chunkYScale: 0.5,
    chunkYOffset: -0.3,
    chunkHalfYExtent: 0.92,
    chunkSurfaceYScaleFactor: 0.5,
    proceduralTopRadiusRatio: 0.85,
    proceduralHeight: 0.6,
  },
  bridge: {
    templateLengthZ: 1.2,
    minTemplateLengthZ: 0.001,
    deckAnchorY: 0,
    minVisibleLength: 0,
    sagFactor: 0.04,
    proceduralWidth: 0.6,
    proceduralHeight: 0.15,
  },
  decoration: {
    scaleMultiplier: 1,
  },
} as const;

export default renderScales;
